module.exports = __webpack_public_path__ + "static/media/eliminar.3271ca23.svg";